import { colorKey, hex2rgbRawStr } from "@helpers/color.helper";
import { loadGmapApi } from "vue2-google-maps";

const state = {
  metaDataID: '',
  pageID: '',
  pageName: '',
  language: "",
  elementID: '',
  main: {
    props: {},
    assets: {
      components: {},
      propertiesData: {},
      styleData: {
        THEME: {
          color: {},
          customColors: [],
          background: {},
          button: {},
          font: {},
          mourning: {},
        },
      },
      data: {}
    }
  },
  activeSection: {},
  screen: {
    SITE: {
      props: {},
      assets: {
        components: {},
        propertiesData: {},
        styleData: {
          THEME: {
            font: {},
          },
        },
        data: {
          theme: {
            font: {}
          },
          socials: {}
        }
      },
    },
    pages: {
      props: {
        components: {
          CONTENT_CONTAINER: {
            componentsID: []
          }
        }
      },
      assets: {
        components: {},
        propertiesData: {},
        styleData: {},
        data: {}
      }
    },

  },
  googleMap: { mapKeyID: "115", googleMapKey: "", isOpenMap: true },
  embedCode: [],
}

const getters = {
  // Appearance
  templateColor: state => {
    const colorset = {}
    new Array(5).fill(0).map((_, color_index) => {
      const mode = state.main.assets.styleData.THEME.color.mode;

      // color1-5
      if (color_index == 0) {
        colorset[colorKey(color_index + 1)] = (mode === 'light') ? hex2rgbRawStr(state.main.assets.styleData.THEME.color.color11) : hex2rgbRawStr(state.main.assets.styleData.THEME.color.color15);
      } else {
        colorset[colorKey(color_index + 1)] = hex2rgbRawStr(state.main.assets.styleData.THEME.color[`color${color_index + 1}`])
      }

      // color11-55
      new Array(5).fill(0).map((_, shade_index) => {
        const shade = (mode === 'light') ? shade_index + 1 : 5 - shade_index
        colorset[colorKey(color_index + 1, shade_index + 1)] = hex2rgbRawStr(state.main.assets.styleData.THEME.color[`color${color_index + 1}${shade}`])
      })
    })
    return colorset
  },
  customColors: state => {
    return state.main.assets.styleData.THEME.customColors
  },
  templateFonts: state => {
    return state.main.assets.styleData.THEME.font
  },
  templateFontsLanguage: state => {
    return state.screen.SITE.assets.styleData.THEME.font
  },
  templateBackground: state => {
    return state.main.assets.styleData.THEME.background
  },
  templateButton: state => {
    return state.main.assets.styleData.THEME.button
  },
  templateButtonLanguage: state => {
    return state.screen.SITE.assets.styleData.THEME.button
  },
  templateMourning: state => {
    return state.main.assets.styleData.THEME.mourning
  },
  appearance: state => {
    return state.main.assets.styleData.THEME
  },
  appearanceLanguage: state => {
    return state.screen.SITE.assets.styleData.THEME
  },

  // MetadataMain
  mainComponentByID: state => {
    return (id) => { return state.main.assets.components[id] };
  },
  mainPropertiesByID: state => {
    return (id) => { return state.main.assets.propertiesData[id] };
  },
  mainStyleByID: state => {
    return (id) => { return state.main.assets.styleData[id] };
  },
  mainDataByID: state => {
    return (id) => { return state.main.assets.data[id] };
  },
  mainComponents: state => {
    return state.main.assets.components;
  },
  mainPropertiesData: state => {
    return state.main.assets.propertiesData;
  },
  mainStyleData: state => {
    return state.main.assets.styleData;
  },
  mainData: state => {
    return state.main.assets.data;
  },
  mainPageProductConfig: state => {
    return state.main.assets.components.PAGE_PRODUCT_CONFIG;
  },
  mainPageProductItemConfig: state => {
    return state.main.assets.components.PAGE_PRODUCT_ITEM_CONFIG;
  },
  mainPageAlbumConfig: state => {
    return state.main.assets.components.PAGE_ALBUM_CONFIG;
  },
  mainPageAlbumItemConfig: state => {
    return state.main.assets.components.PAGE_ALBUM_ITEM_CONFIG;
  },
  mainPageContentConfig: state => {
    return state.main.assets.components.PAGE_CONTENT_CONFIG;
  },
  mainPageContentItemConfig: state => {
    return state.main.assets.components.PAGE_CONTENT_ITEM_CONFIG;
  },
  mainPageProductBrandConfig: state => {
    return state.main.assets.components.PAGE_PRODUCT_BRAND_CONFIG;
  },
  mainPageInformpaymentConfig: state => {
    return state.main.assets.components.PAGE_INFORM_PAYMENT_CONFIG;
  },
  mainPageContactConfig: state => {
    return state.main.assets.components.PAGE_CONTACT_CONFIG;
  },
  mainPageFormItemConfig: state => {
    return state.main.assets.components.PAGE_FORM_ITEM_CONFIG;
  },
  mainPageFAQConfig: state => {
    return state.main.assets.components.PAGE_FAQ_CONFIG;
  },
  mainPageEventCalendarConfig: state => {
    return state.main.assets.components.PAGE_EVENT_CALENDAR_CONFIG;
  },
  mainPageEventCalendarItemConfig: state => {
    return state.main.assets.components.PAGE_EVENT_CALENDAR_ITEM_CONFIG;
  },
  mainPageQuotationFormItemConfig: state => {
    return state.main.assets.components.PAGE_QUOTATION_FORM_ITEM_CONFIG;
  },
  mainPageGiftcardConfig: state => {
    return state.main.assets.components.PAGE_GIFTCARD_CONFIG;
  },
  mainPageSearchConfig: state => {
    return state.main.assets.components.PAGE_SEARCH_CONFIG;
  },
  // MetadataSite
  siteComponentByID: state => {
    return (id) => { return state.screen.SITE.assets.components[id] };
  },
  sitePropertiesByID: state => {
    return (id) => { return state.screen.SITE.assets.propertiesData[id] };
  },
  siteStyleByID: state => {
    return (id) => { return state.screen.SITE.assets.styleData[id] };
  },
  siteDataByID: state => {
    return (id) => { return state.screen.SITE.assets.data[id] };
  },
  siteComponents: state => {
    return state.screen.SITE.assets.components;
  },
  sitePropertiesData: state => {
    return state.screen.SITE.assets.propertiesData;
  },
  siteStyleData: state => {
    return state.screen.SITE.assets.styleData;
  },
  siteData: state => {
    return state.screen.SITE.assets.data;
  },
  sitePage: state => {
    return state.screen.SITE.assets.components[state.pageID]
  },
  sitePageName: state => {
    return state.pageName
  },
  sitePageID: state => {
    return state.pageID
  },
  siteMainPageID: state => {
    return (state.screen.SITE.assets.components.MAIN_PAGE && state.screen.SITE.assets.components.MAIN_PAGE.properties.pageID) || undefined;
  },
  metaDataID: state => {
    return state.metaDataID
  },
  pageID: state => {
    return state.pageID
  },
  siteActiveLanguage: state => {
    return state.language;
  },
  siteStylePageProduct: state => {
    return state.screen.SITE.assets.styleData.STYLE_PAGE_PRODUCT;
  },
  siteStylePageProductItem: state => {
    return state.screen.SITE.assets.styleData.STYLE_PAGE_PRODUCT_ITEM;
  },
  siteStylePageAlbum: state => {
    return state.screen.SITE.assets.styleData.STYLE_PAGE_ALBUM;
  },
  siteStylePageAlbumItem: state => {
    return state.screen.SITE.assets.styleData.STYLE_PAGE_ALBUM_ITEM;
  },
  siteDataPageProduct: state => {
    return state.screen.SITE.assets.data.DATA_PAGE_PRODUCT;
  },
  siteStylePageContent: state => {
    return state.screen.SITE.assets.styleData.STYLE_PAGE_CONTENT;
  },
  siteStylePageContentItem: state => {
    return state.screen.SITE.assets.styleData.STYLE_PAGE_CONTENT_ITEM;
  },
  siteStylePageContact: state => {
    return state.screen.SITE.assets.styleData.STYLE_PAGE_CONTACT;
  },
  siteStylePageFormItem: state => {
    return state.screen.SITE.assets.styleData.STYLE_PAGE_FORM_ITEM;
  },
  siteStylePageProductBrand: state => {
    return state.screen.SITE.assets.styleData.STYLE_PAGE_PRODUCT_BRAND;
  },
  siteStylePageFAQ: state => {
    return state.screen.SITE.assets.styleData.STYLE_PAGE_FAQ;
  },
  siteStylePageEventCalendar: state => {
    return state.screen.SITE.assets.styleData.STYLE_PAGE_EVENT_CALENDAR;
  },
  siteStylePageEventCalendarItem: state => {
    return state.screen.SITE.assets.styleData.STYLE_PAGE_EVENT_CALENDAR_ITEM;
  },
  siteStylePageQuotationFormItem: state => {
    return state.screen.SITE.assets.styleData.STYLE_PAGE_QUOTATION_FORM_ITEM;
  },
  siteStylePageGiftcard: state => {
    return state.screen.SITE.assets.styleData.STYLE_PAGE_GIFTCARD;
  },

  // MetadataPage
  pageComponentByID: state => {
    return (id) => { return state.screen.pages.assets.components[id] };
  },
  pagePropertiesByID: state => {
    return (id) => { return state.screen.pages.assets.propertiesData[id] };
  },
  pageStyleByID: state => {
    return (id) => { return state.screen.pages.assets.styleData[id] };
  },
  pageDataByID: state => {
    return (id) => { return state.screen.pages.assets.data[id] };
  },
  pageComponents: state => {
    return state.screen.pages.assets.components;
  },
  pagePropertiesData: state => {
    return state.screen.pages.assets.propertiesData;
  },
  pageStyleData: state => {
    return state.screen.pages.assets.styleData;
  },
  pageData: state => {
    return state.screen.pages.assets.data;
  },
  CONTENT_CONTAINER: state => {
    return state.screen.pages.props.components.CONTENT_CONTAINER
  },
  components: state => {
    return state.screen.pages.assets.components
  },

  // Other
  googleMap: (state) => {
    return state.googleMap;
  },
  embedCode: (state) => {
    return state.embedCode;
  },
}
const actions = {
  setMainComponent({ commit }, component) {
    return commit('SET_MAIN_COMPONENT', component);
  },
}
const mutations = {
  SET_ACTIVE_LANGUAGE(state, { language }) {
    state.language = language
  },
  SET_ACTIVE_PAGE(state, { metaDataID, pageID, pageName, elementID = '' }) {
    state.metaDataID = metaDataID
    state.pageID = pageID
    state.pageName = pageName
    state.elementID = elementID
  },
  SET_METADATA_SITE(state, SITE) {
    state.screen.SITE = SITE
  },
  SET_METADATA_PAGE(state, pages) {
    state.screen.pages = pages
  },
  SET_MATADATA_MAIN(state, metadata) {
    state.main = metadata
  },

  SET_MAIN_COMPONENT(state, component) {
    state.main.assets.components[component.id] = component
  },
  SET_GOOGLEMAP(state, { key, gmapObj }) {
    state.googleMap = gmapObj;
    loadGmapApi({
      key: key,
      libraries: "places",
      v: 'quarterly',
    });
  },
  SET_EMBEDCODE(state, { embedCode }) {
    state.embedCode = embedCode;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};